module.exports = __webpack_public_path__ + "img/一星特级大师@2x.19030326.png";